import mergeRegistries from '../InterstateBaseThemeProvider/mergeRegistries';
import { InterstateRegistryContext } from './InterstateRegistryContext';
import { jsx as _jsx } from "react/jsx-runtime";
export const InterstateRegistryProvider = _ref => {
  let {
    themeRegistries,
    children
  } = _ref;
  const currentThemeRegistry = mergeRegistries(themeRegistries);
  if (!currentThemeRegistry) {
    throw new Error('The currentThemeRegistry is null. Verify that the themeRegistries parameter of InterstateBaseThemeProvider is correct?');
  }
  return /*#__PURE__*/_jsx(InterstateRegistryContext.Provider, {
    value: currentThemeRegistry,
    children: children
  });
};